module.exports = __webpack_public_path__ + "static/img/hu.a2d301b.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/hu.png
// module id = KuuQ
// module chunks = 1